import {ListView, createInitialState} from "../ListView";
import {Form, FormListener} from "../../form/Form";
import * as React from "react";
import {
    User,
    ListUsersRequest,
    ItemPlayersRequest,
    ItemHistoryListRequest,
    HistoricPlayerItem
} from "../../../../generated/protocol";
import {PagerModel} from "../../list/PagerModel";
import {EntityDataTable} from "../../list/EntityDataTable";
import {ListUtils} from "../../list/ListUtils";
import {RouterView, LoadingViewState} from "../RouterView";
import {kernel} from "../../../ioc/IOCHelper";
import {ItemService} from "../../../service/admin/ItemService";
import {ITEM_HISTORY_SERVICE_NAME, ItemHistoryService} from "../../../service/admin/ItemHistoryService";
import * as DateUtils from "../../../utils/DateUtils";


interface State extends LoadingViewState {
    listRequest?: ItemHistoryListRequest;
    form?: ItemHistoryListRequest;
    validationMap?: any
}

export class UserItemHistoryListView extends ListView<State, ItemHistoryListRequest> implements FormListener<ItemHistoryListRequest> {
    onSubmit: () => (void | Promise<any>);

    columns = [
        {property: "itemNameId", name: "Item", orderBy: "itemNameId"},
        {property: "itemCategory", name: "Category", orderBy: "itemCategory"},
        {property: "subAction", name: "Action", orderBy: "subAction"},
        {property: "actionDetails", name: "Details", orderBy: "actionDetails"},
        {
            property: "timestamp", name: "Timestamp", orderBy: "timestamp", renderer: (property, columnName, item) => {
                console.log(item);
                return DateUtils.iso(item.timestamp)
            }
        },
    ];

    itemHistoryService: ItemHistoryService;

    constructor(props) {
        super(props, "/user/" + props.params.userId);
        this.state = createInitialState({}, {
            listRequest: {
                player: props.params.splat,
                limit: 50,
                orderBy: "timestamp",
                ascending: true
            }
        });
        this.itemHistoryService = kernel.get<ItemService>(ITEM_HISTORY_SERVICE_NAME);
    }

    loadContent(): Promise<any> {
        return undefined;
    }

    formDidUpdate(formModel: ListUsersRequest, validationMap: any): void {
        this.setState({"form": formModel, validationMap: validationMap});
    }

    onSubmitError(): void {

    };

    pagerChanged(pager: PagerModel) {
        var listRequest = ListUtils.toListRequest(this.state.listRequest, pager);
        this.setState({listRequest: listRequest});
    }

    getTitle() {
        return "Items history";
    }

    renderContent() {
        return (
            <div className="ibox player-item-history">
                <div className="ibox-content">
                    <h2>{this.getTitle()}</h2>

                    <EntityDataTable service={this.itemHistoryService} onPagerChange={this.pagerChanged.bind(this)}
                                     columns={this.columns}
                                     listRequest={this.state.listRequest}/>
                </div>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/ui/view/user/UserItemHistoryListView.tsx